(($, Drupal) => {
    Drupal.behaviors.gridDescription = {
        attach: function attach() {
           
            $(".grid-description__view-wrapper").once("grid-description").each(function() {
                const images = $(this).find(".grid-description__view, .grid-description__video");
                images.on("click", function() {
                    console.log(this)
                    const imageWrapper = $("<div>", { class: "slider" });
                    images.each((index, item) => {
                        const imageUrl = $(item).data("image");
                        if(imageUrl) {
                            const image = $("<img>", { src: imageUrl, class: "gallery__overlay-image" })
                                .on("click", function(e) { 
                                    e.stopPropagation(); });
                            imageWrapper.append(image)
                        }
                        else {
                            const videoUrl =  $($(item).find("source")).attr("src");
                            const video = $("<video>", { muted: true, src: imageUrl, class: "video-play gallery__overlay-image" }).html(`<source src="${videoUrl}" type="video/mp4" />`);
                            imageWrapper.append(video);
                            video.trigger("play");
                        }
                    })

                    const overlay = $("<div>", { class: "gallery__overlay overlay__slider" })
                        .on("click", function() { 
                            $("body").removeClass("hide-scroll"); 
                            $(this).remove(); })
                        .append(imageWrapper);
                    $("body").addClass("hide-scroll").prepend(overlay);
                    sliderInit(imageWrapper[0]);
                    $(imageWrapper[0]).data('owl.carousel').options.nav = true;
                    $(imageWrapper[0]).find("." + sliderClasses.navContainerClass).on("click", function(event) {
                        event.stopPropagation();
                    });
                    $(imageWrapper[0]).find("." + sliderClasses.navContainerClass).addClass('default__nav center');
                    
                    const thisImage = this;
                    images.each((index, item) => {
                        if($(item).is(thisImage))
                        {
                            imageWrapper.trigger("to.owl.carousel", [index, 0])
                        }
                    })
                })

                const slider = $($(this).find(".grid-description__preview-wrapper"));

                slider.data('owl.carousel').options.items = 3;
                slider.owlCarousel({
                    nav: true,
                    onInitialized: createItems()
                });
                slider.trigger('refresh.owl.carousel');

                if(slider.find(".grid-description__preview-item").length > 3) {
                    const gridDescription = $(this);
                    gridDescription.find("." + sliderClasses.navContainerClass).addClass('default__nav').addClass('description');
                }
                

                function createItems(event) {
                    const mainWrapper = slider.parent();
                    
                    
                    const elements = slider.find(".grid-description__view, .grid-description__video");


                    const viewWrapper = $("<div>", {
                        class: "grid-description__view-slider-wrapper"
                    }).append(elements.addClass("cloned"));

                    mainWrapper.prepend(viewWrapper);

                    const items = slider.find(".grid-description__preview-item");
                    const clonedItems = viewWrapper.find(".cloned");
                    items.each(function(index) {
                        $(clonedItems[index]).addClass($(this).find("input[type='radio']:checked").length > 0 ? "active" : "");


                        const video = $($(clonedItems[index]).find("video"))
                        video.removeAttr("controls");

                        $(this).on("click", function() {
                            $(clonedItems).removeClass("active");
                            $(clonedItems[index]).addClass("active");
                            
                            clonedItems.each(function() {
                                $($(this).find("video")).trigger("pause")
                            })
                            video.length > 0 && video.trigger("play");
                        })
                    })
                    
                    
                }

        });
        }
    };

})(jQuery, Drupal);
  